<template>
  <b-card>
    <DeleteTagModal
      :tag="toBeEditedTag"
      @hidden="toBeEditedTag = undefined"
      @deleted="fetchList"
    />
    <tag-modal
      :tag="toBeEditedTag"
      @refetch="fetchList"
      @hidden="toBeEditedTag = undefined"
    />
    <b-row class="mb-1">
      <b-col md="3">
        <b-button
          variant="primary"
          @click="newTagHandler"
        >
          Create new tag
        </b-button>
      </b-col>
    </b-row>
    <base-overlay :show="loading">
      <b-table
        hover
        striped
        :items="list"
        :fields="tableColumns"
        show-empty
        empty-text="Empty"
      >
        <template #cell(imageUrl)="data">
          <b-avatar
            v-if="data.item.imageUrl"
            :src="data.item.imageUrl"
          />
        </template>
        <template #cell(actions)="data">
          <div class="d-flex">
            <b-button
              class="btn-icon rounded-circle"
              variant="flat-danger"
              @click="deleteTagHandler(data.item)"
            >
              <feather-icon
                icon="TrashIcon"
              />
            </b-button>
            <b-button
              class="btn-icon rounded-circle"
              variant="flat-primary"
              @click="editTagHandler(data.item)"
            >
              <feather-icon
                icon="EditIcon"
              />
            </b-button>
          </div>
        </template>

      </b-table>
      <base-pagination
        v-model="queryParams.page"
        class="mt-1"
        :total="total"
        @input="fetchList"
        @new-per-page="queryParams.perPage = $event"
      />
    </base-overlay>
  </b-card>
</template>

<script>
import {
  BTable, BCard, BButton, BRow, BCol, BAvatar,
} from 'bootstrap-vue'
import {
  ref, reactive, toRef, watch,
} from '@vue/composition-api'
import BaseOverlay from '@/UI/BaseOverlay.vue'
import BasePagination from '@/UI/BasePagination.vue'
import useRegisterStoreModule from '@/hooks/useRegisterStoreModule'
import businessStore from '../../store'
import TagModal from '../../components/tags/TagModal.vue'
import formatDate from '@/utils/date-format'
import DeleteTagModal from '../../components/tags/DeleteTagModal.vue'

export default {
  components: {
    BButton,
    BRow,
    BAvatar,
    BCol,
    BCard,
    DeleteTagModal,
    BTable,
    BaseOverlay,
    BasePagination,
    TagModal,
  },
  setup(_, ctx) {
    useRegisterStoreModule('business', businessStore)
    const toBeEditedTag = ref()
    const loading = ref(false)
    const total = ref(0)
    const list = ref([])
    const tableColumns = [
      {
        label: 'Name En',
        key: 'name.en',
      },
      { label: 'Name Ar', key: 'name.ar' },
      { label: 'Image', key: 'imageUrl' },
      { key: 'slug' },
      { key: 'order' },
      { key: 'createdAt', formatter: val => formatDate(val) },
      { key: 'updatedAt', formatter: val => formatDate(val) },
      { label: ' ', key: 'actions' },
    ]
    const queryParams = reactive({
      perPage: 10,
      page: 1,
    })

    const fetchList = async () => {
      loading.value = true
      const result = await ctx.root.$store.dispatch('business/getTags', {
        params: queryParams,
      })
      const { tags, total: totalRecords } = result.data.data

      list.value = tags
      total.value = totalRecords
      loading.value = false
    }
    watch([toRef(queryParams, 'perPage')], () => {
      fetchList()
    })
    fetchList()

    const newTagHandler = () => {
      ctx.root.$bvModal.show('businesses-tag-modal')
    }
    const editTagHandler = tag => {
      toBeEditedTag.value = JSON.parse(JSON.stringify(tag))
      ctx.root.$bvModal.show('businesses-tag-modal')
    }
    const deleteTagHandler = tag => {
      toBeEditedTag.value = JSON.parse(JSON.stringify(tag))
      ctx.root.$bvModal.show('delete-tag-modal')
    }

    return {
      tableColumns,
      queryParams,
      list,
      total,
      fetchList,
      loading,
      newTagHandler,
      deleteTagHandler,
      toBeEditedTag,
      editTagHandler,
    }
  },
}
</script>
